import { configureStore } from '@reduxjs/toolkit'
import commitmentSlice from "./slices/commitmentSlice";
import languageSlice from "./slices/languageSlice";
import validatorSlice from "./slices/validatorSlice";




export const store = configureStore({
    reducer: {
        commitment: commitmentSlice.reducer,
        language: languageSlice.reducer,
        validators: validatorSlice.reducer,
    },
})


// WEBPACK FOOTER //
// ./src/state/store.js